import { IDeliveryInfo } from '../types/DeliveryDetails';

export const getDeliveryDetail = (item?: IDeliveryInfo) => ({
  deliveryPrice: item?.deliveryPrice ?? 0,
  deliveryTime: item?.deliveryTime ?? 0,
  workTimeFrom: item?.details?.work_time_from ?? null,
  workTimeTo: item?.details?.work_time_to ?? null,
});
